export default __webpack_public_path__ + "static/media/23t.b31bc711.jpg";